export class ReloadPromotions {
  static readonly type = '[Promotion] Reload Promotions';
}
